import PhonePlanManage from "../components/PhoneplanManage";
import { useState, useEffect } from "react";
import {
  apiRoute,
  requestSecureGet,
  requestSecurePatch,
  requestSecurePost,
} from "@libs/api";
import useToken from "@hooks/useToken";
import { PhoneplanTypes } from "@typedef/components/Telecom/Phoneplan/phoneplan.types";
import { useRecoilValue } from "recoil";
import { getTelecoms } from "@stories/Selector";

type Props = {
  idx?: number;
  close: () => void;
  reload: () => void;
};

// 통신사관리 > 요금제관리 관리 모달
const PhoneplanManageContainer = ({ idx, close, reload }: Props) => {
  const { getToken } = useToken();
  const [inputs, setInputs] = useState<Partial<PhoneplanTypes>>({});
  // 통신사 리스트 조회
  const telecoms = useRecoilValue(getTelecoms(getToken()!));

  // onChange (input)
  const onChangeInputs = (e: { target: HTMLInputElement }) => {
    const { name, value } = e.target;
    setInputs((inputs) => ({
      ...inputs,
      [name]: value,
    }));
  };

  // onChange (select)
  const onChangeSelect = <T extends {}>(name: string, selected: T) => {
    setInputs((inputs) => ({
      ...inputs,
      [name]: selected,
    }));
  };

  // 등록
  const insert = async () => {
    const { config } = await requestSecurePost(
      apiRoute.telecom.phoneplan.postPhoneplan,
      {},
      inputs,
      getToken()!
    );
    if (config.status >= 200 && config.status < 400) {
      alert("성공적으로 등록이 완료되었습니다.");
      close();
      reload();
    }
  };

  // 수정
  const update = async () => {
    const { config } = await requestSecurePatch(
      apiRoute.telecom.phoneplan.patchPhoneplan,
      {},
      { ...inputs, phonePlanId: idx },
      getToken()!
    );
    if (config.status >= 200 && config.status < 400) {
      alert("성공적으로 수정이 완료되었습니다.");
      close();
      reload();
    }
  };

  const getCheckedData = async () => {
    const { config, data } = await requestSecureGet<{
      phonePlan: PhoneplanTypes;
    }>(apiRoute.telecom.phoneplan.getPhoneplan + idx, {}, getToken()!);
    if (config.status >= 200 && config.status < 400) {
      setInputs(data.phonePlan);
    }
  };

  useEffect(() => {
    if (idx) {
      getCheckedData();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [idx]);

  return (
    <PhonePlanManage
      type={idx ? "수정" : "등록"}
      inputs={inputs}
      onChangeInputs={onChangeInputs}
      onChangeSelect={onChangeSelect}
      telecoms={telecoms}
      save={idx ? update : insert}
    />
  );
};

export default PhoneplanManageContainer;
